// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { convertDMStoDD } from 'helpers/coordsConversion'
import { valueAsMeters } from 'helpers/unitConversion'
import getSelectedSegmentEnds from './getSelectedSegmentEnds'

// returns an array of callsign cascade trigger data

// NOTE - for each if here, we ensure the value is truthy before comparing with the
// segment end data. This is because we have no initial values to compare to and
// instead, we determine if a modify value was defined in the input field.

const compareTriggerValuesWithSegmentEnd = triggerFields => (dispatch, getState) => {
  const unitType = getState().bulkEdit.get('unitType')
  const selectedSegmentEnds = dispatch(getSelectedSegmentEnds())

  return selectedSegmentEnds.reduce((a, d) => {
    const oldTriggeredValues = {}

    if (triggerFields.siteName && triggerFields.siteName !== d.get('siteName')) {
      oldTriggeredValues.siteName = d.get('siteName')
    }

    if (triggerFields.contactId && triggerFields.contactId !== d.get('contactId')) {
      oldTriggeredValues.contactId = d.get('contactId')
    }

    // Compares the initial DMS value to the submit DMS value
    // then stores the initial value as DD
    if (triggerFields.latitude && triggerFields.latitude !== d.get('latitude')) {
      oldTriggeredValues.latitude = convertDMStoDD(d.get('latitude'))
    }

    // Compares the initial DMS value to the submit DMS value
    // then stores the initial value as DD
    if (triggerFields.longitude && triggerFields.longitude !== d.get('longitude')) {
      oldTriggeredValues.longitude = convertDMStoDD(d.get('longitude'))
    }

    // compares the two elevation values as they are. when creating triggerFields
    // we ensure that triggerFields.elevation is the same unit as the stored
    // values in projectSummary path data.
    // TODO NEXT - confirm this is correct
    if (triggerFields.elevation && triggerFields.elevation !== d.get('groundElevation')) {
      oldTriggeredValues.elevation = valueAsMeters(d.get('groundElevation'), unitType)
    }

    if (triggerFields.asr && triggerFields.asr !== d.get('asr')) {
      oldTriggeredValues.asr = d.get('asr')
    }

    if (triggerFields.callSign && triggerFields.callSign !== d.get('callSign')) {
      oldTriggeredValues.callSign = d.get('callSign')
    }

    // finally, if any of the trigger fields had values which were not the already stored values for the selected segment ends,
    // then we'll add that to the list of segment ends which should be included in the callsign cascade aggregate/match
    if (Object.keys(oldTriggeredValues).length > 0) {
      a.push({
        segmentEndId: d.get('segmentEndId'),
        oldTriggeredValues,
      })
    }

    return a
  }, [])
}

export default compareTriggerValuesWithSegmentEnd
